import * as React from 'react';
import { secondaryDimensionListContext } from './context';
export var SecondaryDimensionListContextProvider = function (props) {
    var secondaryDimensionList = props.secondaryDimensionList, children = props.children;
    return (React.createElement(secondaryDimensionListContext.Provider, { value: secondaryDimensionList }, children));
};
